import React from 'react';
import Header from '../Header';
import Footer from './Footer';
import useCondition from '../../useCondition';

const IsUnsubscribedFilter = () => {
  const {condition, setCondition} = useCondition();

  return (
    <>
      <Header title="配信停止" />
      <div className="p-6 bg-c-bg flex-1 flex flex-col gap-4 rounded-b overflow-y-scroll">
        <div className="bg-white p-6 rounded flex flex-col gap-2">
          <label className="flex items-center text-base">
            <input
              type="radio"
              name="isUnsubscribed"
              checked={condition.isUnsubscribed === false}
              className="form-radio h-5 w-5 border-c-border rounded-full text-c-primary"
              onChange={() => setCondition({isUnsubscribed: false})}
            />
            <span className="ml-2">配信</span>
          </label>
          <label className="flex items-center text-base">
            <input
              type="radio"
              name="isUnsubscribed"
              checked={condition.isUnsubscribed === true}
              className="form-radio h-5 w-5 border-c-border rounded-full text-c-primary"
              onChange={() => setCondition({isUnsubscribed: true})}
            />
            <span className="ml-2">配信停止</span>
          </label>
        </div>
      </div>
      <Footer onClear={() => setCondition({isUnsubscribed: null})} />
    </>
  );
};

export default IsUnsubscribedFilter;
